<header class="mast-main-head fixed-top">

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

    <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link marketplace" href="javascript:;" (click)="openMarketplace()">Marketplace</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="javascript:;" routerLink="/pricing">Pricing</a>
        </li>
        <li class="nav-item dropdown col-1-dropdown">
          <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
          <div class="dropdown-menu" style="width: 200px;">
            <ul>
              <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="Icons/Navigation/Arrow Down/Black">
                    <g id="Group">
                      <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                  </g>
                </svg> -->
              </li>
              <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
              <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
        </li>
        <li class="nav-item signup-btn">
          <a class="nav-link button" data-toggle="modal" routerLink="/login">Start for free</a>
       </li>
       <li class="nav-item login-btn">
       <!-- <a class="nav-link btn" data-toggle="modal" routerLink="/login" data-target="#loginmodal">Login</a> -->
       </li>
      </ul>
      </div>
    </div>
    </nav>
</header>

<section class="partner-main-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h2>Our Guidelines</h2>
        <p>For being an active member of Crafttor Workspace you are always cheered up. Before you start uploading, please read our guidelines, terms and privacy policies.</p>
        <div class="btn-wrapper">
          <a class="button enterprise-buy-now" style="background: #000000; color: #ffffff;" (click)="openLetsTalkDialog(letsTalk)">Book Demo</a>
          <a class="button light-blue-btn" style="color: #2d7cff;" routerLink="/login">Start for free</a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="terms-privacy-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3><a class="terms-text" *ngIf="termsClicked" style="color: #2d7cff" (click)="termsClick()">Terms of use</a>
            <a class="terms-text" *ngIf="!termsClicked" style="" (click)="termsClick()">Terms of use</a>
             <a class="privacy-text active" *ngIf="privacyClicked" style="color: #2d7cff" (click)="privacyClick()">Privacy Policy</a>
             <a class="privacy-text active" *ngIf="!privacyClicked" (click)="privacyClick()">Privacy Policy</a></h3>
          <hr>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="terms-section" *ngIf="termsSection">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h5><b class="last-updated">LAST UPDATED:</b> <span>JUNE 3'2024</span></h5>
          <p>Please read the Terms of use carefully before taking any action on the website. By using or accessing the assets of Crafttor Technologies i.e products, services, websites, applications, images, illustrations etc or collectively the whole platform, You agree to accept by and bound by the terms of Crafttor Technologies described herein or described by all the terms & conditions, policies & guidelines incorporated by any reference. This Terms of use describes the rights and responsibilities that apply to your use of Crafttor's workspace website or mobile apps or any services, products owned by Crafttor Technologies.</p>
          <br>
          <p>If you do not agree to our Terms of use, then don’t use any of the Crafttor’s Products/Services, Websites/Mobile   Apps.<br>
            You are only allowed to use Crafttor’s Website/mobile apps, products and services if you agree to abide by and be bound by the terms.</p><br>
            <h6>Workspace account</h6>
            <p>A user can own one workspace account with one email Id. The user who is going to initiate creating an account can create workspace and can further invite other users to access the same account. The owner of the account is responsible for any uploading/downloading of images/assets. In case user deletes the data of his/her own workspace then Crafttor is not responsible for any loss. We hereby inform that Crafttor's workspace is a platform for storing and accesing digital assets. We don't look into the workspace of any user and we will not be responsible if the account owner or the user to which owner has given access deletes the data or deletes the workspace. </p>
            <br>
            <p><b>NOTE: </b>A workspace once deleted can't be recovered again. Use each and everything very neatly.</p>
            <br>
            <h6>Payment, Refunds, Upgrading plans, Upgrade subscription, Price hike</h6>
            <p><b>Payments,</b> A user who is the owner of the account can have access to change/upgrade a plan. Crafttor considers the person as owner of the account under whose name provided or appears on the credit or charge card or other payment method that pays the charges for the Service to be the owner of the Paid Account. If any other name is used for paying the membership payment of Crafttor’s account then the company considers that name/person to be the owner of the account. If any dispute arises as to who owns or controls a Paid Account, then the company (Crafttor) is liable to access the true information of the paid member via Name and Card Information provided at the time of buying the membership. Currently we don’t have Auto-renewals of the account, so which Name or Card details provided at the time of buying the membership should be considered the owner of the Paid Account.</p>
            <p><b>Refunds,</b> If a user wishes not to continue using Crafttor Workspace or any other services in between(before time) then in that case no refund for the accounts will be initiated.</p>
            <p><b>Upgrading plans,</b> If users wishes to upgrade their plan then they have to pay as per the plan the full amount at once for the year and can continue using the workspace account with upgraded features. We have 3 plans in total other than Free plan. All the other(paid) plans have features based on the requirements. Users can pick plan as per their needs.</p>
            <p><b>Upgrade subscription,</b> If users wish to upgrade their current subscription, they must either pay the full amount of the new plan or a pro-rata amount based on the remaining time in their current plan. Users can upgrade from our Plus plan to the Professional plan. In case a user wishes to upgrade to a custom plan, the charges will be based on the custom requirements</p>
            <p><b>Price hike,</b> Whenever there is an increase in server prices(AWS prices), our plan prices may increase accordingly, and users will have to pay the new amount as per their chosen plan.</p>
            <br>
            <h6>Rules</h6>
            <p>Use of any product/ services of Crafttor’s Technologies is subject to following rules of the company. You agree to our terms of use and guidelines along with that you have to agree for the rules and regulations of Crafttor Technologies. And you will not do any of the following.</p>
            <br>
            <ul>
              <li>Reverse engineer on the platform, decompile the code/product, disassemble, decipher or otherwise attempt to derive the source code for the Services or any related technology that we have not made open source.</li>
              <li>
                The current Beta version of the Content Library is now available to all users. However, the terms will be updated later for free users and those coming from different platforms like AppSumo, DealMirror, etc.
              </li>
              <li>
                Crafttor offers various products, including Workspace, Content Library, Marketplace, and more. The Content Library is not a part of Crafttor Workspace, so its terms and usage will be updated according to the specific plans.
              </li>
              <li>Rent/Lease our services based on your account, trade/sell/resell or otherwise monetize the Services or related data or access to the same, without company’s express written consent or any legal notice by the company.</li>
              <li>Monitor the Services’ availability, performance or functionality for any competitive purpose.</li>
              <li>You will not post anything that contains software viruses, worms, or any other harmful code, assets/images or videos that affect the Crafttor’s platform.</li>
              <li>Violate Crafttor’s intellectual property rights or the intellectual property rights of others.</li>
              <li>Override any security feature or bypass or circumvent any access controls or limits of the Services provided by Crafttor Technologies.</li>
              <li>Create any of your false identity or misrepresent your identity, create a profile for anyone else other than yourself, or use or attempt to use another user account by hacking or any mode.</li>
            </ul>
            <p>Crafttor Technologies reserves the right to take legal action if a user did any of the above mentioned which is against company’s rule.</p>
            <br>
            <h6>Content ownership</h6>
            <p>Crafttor claim no intellectual property rights over the files you provide to the Workspace. Your profile, assets and files uploaded by you remain yours. However, if you share your files publicly or you agree to allow others to view your content via share or invite feature then it is you who is the owner of all those activities. Crafttor has no involvement in any activity.</p>
            <br>
            <h6>Harassment</h6>
            <p>Crafttor Workspace users are prohibited from harassing other workspace users or anyone and in any way (for example, offensive remarks, sharing harrasing files, videos etc). If any account is found doing harrasing activities then Crafttor has all the rights to terminate the account immediately without any notice or intimation to account owner.</p>
            <br>
            <h6>Termination of account</h6>
            <p>Crafttor may terminate this agreement or any type of account (Simple/Paid), full or partial services, with or without cause, with or without any notice effective immediately, If the company finds anything misleading or unlawful. If a user wishes to terminate all the services before time then no refund for the paid accounts or any kind of payments happened will be initiated. Crafttor Technologies is liable not to refund the amount or initiate any amount transfer for the same in any case.</p>
            <br>
            <h6>Connect</h6>
            <p>If you have any query about our Terms of use, to make a complaint in any case, you can email us at <b><a href="mailto:info@crafttor.com">info@crafttor.com</a></b></p>
            <p>Be a Crafttor’s workspace user and enjoy unlimited storing/accessing of images, illustrations, pictures etc.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="privacy-section" *ngIf="privacySection">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h5><b class="last-updated">LAST UPDATED:</b> <span>JUNE 3'2024</span></h5>
          <p>Crafttor dedicatedly committed to protect its users' privacy of personal information against any breaching. Crafttor’s users can refer to our privacy policy for further information on how we collect & use our users information and in any legal case in which Crafttor is required to disclose its users privacy then how confidentially it is disclosed.</p>
          <br>
          <h6>Information collection and its use on Crafttor's workspace</h6>
          <p>When a user registers on our website we strictly follow security rules to purely secure our user’s personal information. We require little information from the user’s end like User’s Image, Name, Email, Location and all the gathered information is safely inserted in our systems. We have tight control and security features to protect all the confidential information from any kind of breaching. We gather some personal information to create a user's account(simple account). For Paid Account we do not keep any information related to credit/debit cards and any net banking information.</p>
          <br>
          <h6>Private until you choose to share further</h6>
          <p>Your assets/images, files, data or whatever you have uploaded is private until you choose to share it with anyone else via invite user or sharing features of Crafttor Workspace. Until you share the sharable link or invite accepted everything of your's inside the workspace is private.</p>
          <br>
          <!-- <h6>Children's privacy</h6>
          <p>Crafttor do not knowingly collect, maintain, or use personal information from children under 16 years of age, & if that can be happen anytime and you come to know that your child has shared us with their personal information without your consent, then you may alert us anytime at <b>info@crafttor.com</b>. If we learn that we have collected any personal information from children under 16, then we will promptly take steps to delete such information.</p>
          <br> -->
          <h6>Cookies & log files</h6>
          <p>We use cookies and log files to track user information. Cookies are small amounts of data that are transferred to your web browser by a web server and are stored on your computer’s hard drive. We use cookies to track which page variant a visitor has seen, to track if a visitor has clicked on a page variant, to monitor traffic patterns and to gauge popularity of service options. We will use this information to deliver relevant content and services to you.</p>
          <br>
          <h6>Rights to your information</h6>
          <p>A user has the right to their information but currently we do not provide any way out via which a user can edit their information other than name. A user can access or ask for their personal information anytime via email. In case if a user feels like someone else is using their account then they can directly drop us an email at <b><a href="mailto:info@crafttor.com">info@crafttor.com</a></b> and we will take necessary actions against that account after full inspection, verification and security check of the account. However, to make sure that the personal information we maintain about you is accurate and up to date, please inform us immediately of any change in your personal information over email. </p>
          <br>
          <h6>Policy updates</h6>
          <p>We may update our Privacy Policy from time to time. If we do so, we will send an email to all the users specified that our privacy policies have changed and please read it once to update yourself. A user can also subscribe to us to get up-to-date information and for that user should update their email address to us.(A user is responsible for ensuring that Crafttor has their up-to-date email address for this purpose).</p>
          <br>
          <h6>Connect</h6>
          <p>If you have any query about our Privacy Policy or about your personal information, to make an access to your privacy policy or personal information or any information correction request, to make a complaint in any case, you can email us at <b><a href="mailto:info@crafttor.com">info@crafttor.com</a></b>.</p>
          <p>Be a Crafttor’s workspace user and enjoy unlimited storing/accessing of images, illustrations, pictures etc.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="site-footer">
  <div class="container">
    <div class="row">
      <div class="col-sm-3">
        <div class="coulmn-1">
          <img src="assets/img/logo.svg">
          <p>Digital assets management</p>
          <a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
        </div>
      </div>
      <!-- 3 -->
      <div class="col-sm-2">
        <h5>Products</h5>
        <ul class="menu">
          <li><a routerLink="/home">Workspace</a></li>
          <li><a (click)="openMarketplace()">Marketplace</a></li>
          <li><a routerLink="/features">Features</a></li>
          <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
          <li><a routerLink="/smart-storage">Smart storage</a></li>
          <li><a routerLink="/effective-search">Effective search</a></li>

        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Plugins</h5>
        <ul class="menu">
          <li><a href="javascript:;" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
          <li><a href="javascript:;" href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
          <li><a href="javascript:;" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
          <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
          <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
          <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
          <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
          <li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Solutions</h5>
        <ul class="menu">
          <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
          <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
          <li><a routerLink="/box-alternative">Box alternative</a></li>
          <li><a routerLink="/content-library">Content library</a></li>
          <li><a routerLink="/user-profiling">User Profiling</a></li>
          <li><a routerLink="/approvals">Creative approvals</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Features</h5>
        <ul class="menu">
          <li><a routerLink="/features/tagging">Tagging</a></li>
          <li><a routerLink="/features/sharing">Sharing</a></li>
          <li><a routerLink="/features/versioning">Versioning</a></li>
          <li><a routerLink="/features/collaboration">Collaboration</a></li>
          <li><a routerLink="/features/integration">Integration</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Company</h5>
        <ul class="menu">
          <li><a routerLink="/about-workspace">About Workspace</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
          <li><a routerLink="/terms">Terms & Conditions</a></li>
          <li><a routerLink="/faq">FAQ</a></li>
          <li><a routerLink="/feedbacks">Feedback</a></li>
          <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
          <li><a routerLink="/our-mission">Our mission</a></li>
          <li><a routerLink="/partner-with-us">Partner with us</a></li>
        </ul>
      </div>

      <div class="col-sm-3 all-social-icons">
        <h5>Socials</h5>
          <ul class="social-icons">
            <li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
              alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
            <li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
            <li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
            <li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
            <li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
            <li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
            <li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
          </ul>
      </div>

      <div class="col-sm-12 text-center">
          <small>&copy; 2025 Crafttor. All rights reserved</small>
        </div>
    </div>
  </div>
</footer>

<ng-template #letsTalk let-letsTalk>
    <div class="custom-dialog custom-dialog-centered sign-up" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="letsTalk.close()">
          </button>
        <div class="modal-body">
      <h2>Let's talk!</h2>
      <p>Schedule a free demo today. We will show you a demo of how Crafttor Workspace works.</p>
      <div class="form-wrapper">
        <form class="row g-3" [formGroup]="letsTalkForm" (ngSubmit)="submitContactUs(selectDate)">
          <div class="col-md-6">
          <label class="form-label">First Name<span>*</span></label>
          <input id="textinput" formControlName="name" type="text" placeholder="Brian" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.name.touched || submitted) && letsTalkForm.controls.name.errors?.required">
          First Name is required
        </span>
          </div>
          <div class="col-md-6">
          <label class="form-label">Last Name<span>*</span></label>
          <input id="textinput" formControlName="lname" type="text" placeholder="Storm" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.lname.touched || submitted) && letsTalkForm.controls.lname.errors?.required">
          Last Name is required
        </span>
          </div>
          <div class="col-12">
          <label for="businessEmail" class="form-label">Business Email<span>*</span></label>
          <input id="textinput" formControlName="email" type="email" placeholder="abc@crafttor.com" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.required">
          Email is required
        </span>
        <span class="text-danger error-text"
        *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.pattern">
        Email is not valid
      </span>
          </div>
          <div class="col-12">
          <label for="company" class="form-label">Company<span>*</span></label>
          <input id="textinput" formControlName="company" type="text" placeholder="Crafttor" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.company.touched || submitted) && letsTalkForm.controls.company.errors?.required">
          Company Name is required
        </span>
          </div>

          <div class="col-md-12" style="display: none;">
            <label class="form-label" for="textarea">Message</label>
            <input id="textinput" formControlName="message" type="text" class="form-control input-md" required>
            <span class="text-danger error-text"
            *ngIf="(letsTalkForm.controls.message.touched || submitted) && letsTalkForm.controls.message.errors?.required">
            Message is required
          </span>
          </div>


          <div class="col-12">
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!showLeaveLoader">Submit</button>
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          </div>
        </form>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>


<ng-template #selectDate let-selectDate>
    <div class="custom-dialog custom-dialog-centered select-time-popup" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="selectDate.close()">
          </button>
        <div class="modal-body">
      <h6>{{thankYouText}}</h6>
      <h6>(IST)</h6>
      <div class="form-wrapper">
        <ul class="date-listing" *ngFor="let slots of availableSlots | slice:1:5; let i = index">
          <li *ngIf="showDate">
            <div class="date-list" (click)="selectDateSales(slots.date, slots.day, slots.month)">
              <!-- <div class="date-list-day" style="background: #f9f9f9">
                <a href="javascript:;">{{slots.day}}</a>
              </div> -->
              <div class="">
                <a href="javascript:;">{{slots.month}} {{slots.date1}}</a>
              </div>
              <!-- <a href="javascript:;">{{slots.month}}</a> -->
            </div>
          </li>
        </ul>

        <div *ngIf="!showDate" class="selected-date">
          <div class="date-list-days">
            <a href="javascript:;">{{shownDay}}</a>
          </div>
          <div style="padding-top:10px;" class="">
            <a href="javascript:;">{{shownDate}}</a>
          </div>
          <!-- <a href="javascript:;">{{shownMonth}}</a> -->
        </div>

        <p *ngIf="!showDate" (click)="changeDate()" class="change-date-txt">Change Date</p>

        <h6 style="margin-top:20px;" *ngIf="showTime">What time works?</h6>

        <ul *ngFor="let time of availableTimeSlots; let i = index">
          <li *ngIf="showTime">
            <div class="time-list" (click)="selectTimeSales(time)">
              <div style="text-align: center;" class="">
                <a href="javascript:;">{{time}}</a>
              </div>
            </div>
          </li>
        </ul>
        <div *ngIf="showFinalTime" style="text-align: center;" class="selected-time">
          <a href="javascript:;">{{shownTime}}</a>
        </div>
        <p *ngIf="!showTime" (click)="changeTime()" class="change-time-txt"></p>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" (click)="contactSalesCall(thankyou); selectDate.close()" *ngIf="timeSelected && dateSelected && showSubmitBtn">Submit</button>
        <p *ngIf="showSelectionMessage" class="text-danger error-text" style="text-align: center; margin-top:10px; font-weight: 600">{{showSelectedMsg}}</p>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>

<ng-template #showloader let-showloader>
  <div class="custom-dialog custom-dialog-centered show-loader" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <img class="main-loader-img" style="margin-top: 200px; width: 180px;" src="assets/img/loader.svg" alt="">
        <h6 style="font-size: 16px;">Please wait</h6>
        <p>Confirming your meeting time..</p>
      </div>
  </div>
</div>
</ng-template>


<ng-template #thankyou let-thankyou>
  <div class="custom-dialog custom-dialog-centered thanks-popup" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h5>Thank you <br>Your meeting is confirmed. </h5>
          <div class="conver-grid">
            <div class="img-wrapper">
              <img src="" >
              <img src="assets/img/tick.png" class="tick">
            </div>
          <p>You are meeting with</p>
          <h4>Sandeep Virk</h4>
          </div>
      <div class="invitation-wrapper">
        <div class="">You will receive a meeting invitation shortly</div>
          <table>
          <tbody>
            <tr>
              <th>Event</th>
              <td>Crafttor intro with Sandeep</td>
            </tr>
            <!-- <tr>
              <th>Time</th>
              <td>Friday, Oct 22nd, 08:30PM - 9:00PM IST</td>
            </tr> -->
            <tr>
              <th>Guest</th>
              <td>{{userName}}<span><a>{{userEmail}}</a></span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <button id="singlebutton" name="singlebutton button" class="btn btn-primary" style="width: 100%;
    margin-top: 20px;" (click)="closeThankDialog()">Close</button>
    </div>
  </div>
</div>
</ng-template>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':sendingProcessStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<img class="main-loader-img" style="width: 140px;" src="assets/img/loader.svg" alt="">
			  <h6 style="font-size: 16px;">Please wait</h6>
			  <p>Confirming your meeting time..</p>
			</div>
		</div>
	</div>
</div>
